import { render, staticRenderFns } from "./AddressWindow.vue?vue&type=template&id=f74d2ed4"
import script from "./AddressWindow.vue?vue&type=script&lang=js"
export * from "./AddressWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports